import { OrderDirection } from "common/contracts/order-direction";

export enum DocumentOrderField {
  Name = 'name',
  Label = 'context',
  Created = 'created',
  Size = 'fileSize',
}

export class DocumentOrderParameters {
  orderBy: DocumentOrderField;
  orderDir: OrderDirection;

  constructor(
    orderBy: DocumentOrderField,
    orderDir: OrderDirection
  ) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public asSearchParams(): URLSearchParams {
    const params = new URLSearchParams();
    params.append(
      "orderBy",
      this.orderBy
    );
    params.append(
      "orderDir",
      this.orderDir
    );
    return params;
  }

  public isEqualTo(other: DocumentOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}

export class DocumentFilterParameters {
  name?: string;
  minCreatedDate?: string;
  maxCreatedDate?: string;
  query?: string;
  entityClass?: string;
  entityId?: string;
  contexts?: string[];

  constructor({
    entityClass,
    entityId,
    name,
    contexts,
    minCreatedDate,
    maxCreatedDate,
    query,
  }: {
    entityClass?: string;
    entityId?: string;
    name?: string;
    contexts?: string[];
    minCreatedDate?: string;
    maxCreatedDate?: string;
    query?: string;
  } = {}) {
    this.entityClass = entityClass;
    this.entityId = entityId;
    this.name = name;
    this.contexts = contexts;
    this.minCreatedDate = minCreatedDate;
    this.maxCreatedDate = maxCreatedDate;
    this.query = query;
  }

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.entityClass) searchParams.append(
      "entityClass",
      this.entityClass
    );
    if (this.entityId) searchParams.append(
      "entityId",
      this.entityId
    );
    if (this.contexts) {
      this.contexts.forEach(context => {
        if (context) {
          searchParams.append("contexts", context);
        }
      })
    }
    if (this.name) searchParams.append(
      "name",
      this.name
    );
    if (this.minCreatedDate) searchParams.append(
      "minCreatedDate",
      this.minCreatedDate
    );
    if (this.maxCreatedDate) searchParams.append(
      "maxCreatedDate",
      this.maxCreatedDate
    );
    if (this.query) searchParams.append(
      "query",
      this.query
    );
    return searchParams;
  }

  public isEqualTo(other: DocumentFilterParameters): boolean {
    if (!other) return false;
    return (this.entityClass === other.entityClass &&
      this.entityId === other.entityId &&
      this.name === other.name &&
      ((!this.contexts && !other.contexts) ||
        this.contexts?.length === other.contexts?.length &&
        this.contexts?.every(
          (context) => other.contexts?.some(otherContext => otherContext == context))
      ) &&
      this.minCreatedDate === other.minCreatedDate &&
      this.maxCreatedDate === other.maxCreatedDate &&
      this.query === other.query) ?? false;
  }
}


export default class DocumentParameters {
  orderParameters: DocumentOrderParameters;
  filterParameters: DocumentFilterParameters;

  constructor(
    orderParameters: DocumentOrderParameters,
    filterParameters: DocumentFilterParameters,
  ) {

    this.orderParameters = orderParameters;
    this.filterParameters = filterParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.orderParameters.asSearchParams(),
      ...this.filterParameters.asSearchParams()
    ]);
  }

  public isEqualTo(other: DocumentParameters | undefined): boolean {
    if (!other) {
      return false;
    }

    return this.orderParameters.isEqualTo(other.orderParameters) &&
      this.filterParameters.isEqualTo(other.filterParameters);
  }
}
